/**
 * ICD Codes API
 * Manages the global ICD-10 codes list (shared across all patients)
 */

import { apiClient } from './config';

export const fetchICDCodes = async () => {
  const response = await apiClient.get('/get-codes');
  return response.data;
};

export const addICDCode = async (code, name) => {
  const response = await apiClient.post('/add-code', { code, name });
  return response.data;
};
